import { IListStepEvaluationProps } from './components/ListStepEvaluation';
import { IStepEvaluationProps } from './components/StepEvaluation';
import { IFullListStepEvaluationProps } from './components/FullListStepEvaluation';
import { IResolvedAnchorValueProps } from './components/ResolvedAnchorValue';
import { IActionListProps } from './actions/ActionList';
import { IOutputListProps } from 'domains/designers/RuleDesigner/components/OutputList';
import { renderComponent } from 'utils/RenderingUtils';

export async function renderListStepEvaluation(
  props: IListStepEvaluationProps,
  container: HTMLElement,
  callback?: () => void
) {
  const { ListStepEvaluation } = await import('domains/designers/RuleDesigner/components/ListStepEvaluation');

  return renderComponent({
    container,
    component: <ListStepEvaluation {...props} />,
    autoUnmount: true,
    callback,
  });
}

export async function renderStepEvaluation(props: IStepEvaluationProps, container: HTMLElement, callback?: () => void) {
  const { StepEvaluation } = await import('domains/designers/RuleDesigner/components/StepEvaluation');

  return renderComponent({
    container,
    component: <StepEvaluation {...props} />,
    autoUnmount: true,
    callback,
  });
}

export async function renderFullListStepEvaluation(
  props: IFullListStepEvaluationProps,
  container: HTMLElement,
  callback?: () => void
) {
  const { FullListStepEvaluation } = await import('domains/designers/RuleDesigner/components/FullListStepEvaluation');

  return renderComponent({
    container,
    component: <FullListStepEvaluation {...props} />,
    callback,
    autoUnmount: true,
  });
}

export async function renderResolvedAnchorValue(
  props: IResolvedAnchorValueProps,
  container: HTMLElement,
  callback?: () => void
) {
  const { ResolvedAnchorValue } = await import('domains/designers/RuleDesigner/components/ResolvedAnchorValue');

  return renderComponent({
    container,
    component: <ResolvedAnchorValue {...props} />,
    callback,
    autoUnmount: true,
  });
}

export async function renderRuleActionList(props: IActionListProps, container: HTMLElement, callback?: () => void) {
  const { ActionList } = await import('domains/designers/RuleDesigner/actions/ActionList');

  return renderComponent({
    container,
    component: <ActionList {...props} />,
    callback,
    autoUnmount: true,
  });
}

export async function renderRuleOutputList(props: IOutputListProps, container: HTMLElement, callback?: () => void) {
  const { OutputList } = await import('domains/designers/RuleDesigner/components/OutputList');

  return renderComponent({
    container,
    component: <OutputList {...props} />,
    callback,
    autoUnmount: true,
  });
}
